module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/11a377d4473321b3397440c222212b96.png";